/** Inclusive YYYY-MM-DD range compare (ISO date strings). */
export function legInClosedDateRange(
  flightDate: string,
  startIso: string,
  endIso: string
): boolean {
  const d = flightDate.trim().slice(0, 10);
  const a = startIso.trim().slice(0, 10);
  const b = endIso.trim().slice(0, 10);
  return d >= a && d <= b;
}

export function routeSnippet(route: string | null | undefined, max = 80): string {
  const t = (route ?? "").replace(/\s+/g, " ").trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1)}…`;
}
